import { render, staticRenderFns } from "./BuyBtn.vue?vue&type=template&id=0847b5e4&scoped=true&"
import script from "./BuyBtn.vue?vue&type=script&lang=ts&"
export * from "./BuyBtn.vue?vue&type=script&lang=ts&"
import style0 from "./BuyBtn.vue?vue&type=style&index=0&id=0847b5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847b5e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
